<template>
  <div>
    <p>{{ formattedTime }}</p>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    elapsedTime: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      timer: null,
      localElapsedTime: this.elapsedTime,
    };
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.localElapsedTime / 60);
      const seconds = this.localElapsedTime % 60;
      return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    },
    ...mapState({
      isPaymentDone: (state) => state.customerActivationNew.isPaymentDone,
    }),
  },
  watch: {
    elapsedTime(newTime) {
      this.localElapsedTime = newTime;
    },
    localElapsedTime(newTime) {
      if (newTime === 0 && !this.isPaymentDone) this.onTimerEnd();
    },
    isPaymentDone(newStatus) {
      if (newStatus) this.stopTimer();
    },
  },
  mounted() {
    this.startTimer();
  },
  beforeUnmount() {
    this.stopTimer();
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        if (this.localElapsedTime > 0) {
          this.localElapsedTime--;
          this.$emit("update-timer", this.localElapsedTime);
        } else {
          this.stopTimer();
        }
      }, 1000);
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    onTimerEnd() {
      this.$router.push("/customers/customer_activation/sim-info");
      this.$store.commit("customerActivationNew/setElapsedTime", 360);
      this.startTimer();
    },
  },
};
</script>
